import React from 'react';
import { Navbar, PageNotFound } from '../../../components';

const Achievements = () => {
  return (
    <>
      <Navbar />
      <PageNotFound />
    </>
  );
};

export default Achievements;